import { render, staticRenderFns } from "./KimSpellsComponent.vue?vue&type=template&id=131e1785&scoped=true"
import script from "./KimSpellsComponent.vue?vue&type=script&lang=ts"
export * from "./KimSpellsComponent.vue?vue&type=script&lang=ts"
import style0 from "./KimSpellsComponent.vue?vue&type=style&index=0&id=131e1785&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e1785",
  null
  
)

export default component.exports